export const SITE_NAME = 'Bare Force One LLC';
export const OG_IMAGE = 'https://bareforceone.com/og-image.jpg';

export const ROUTE_SEO = {
  '/': {
    title: 'Custom Software Development',
    description: 'Bare Force One builds custom software, digital transformation, workflow automation, portals, and web platforms for government, enterprise, and local teams.',
    path: '/'
  },
  '/government': {
    title: 'Government Software Development',
    description: 'Custom software, secure portals, workflow automation, and modernization planning for local and state government teams.',
    path: '/government'
  },
  '/citizen-request-management-software': {
    title: 'Citizen Request Management Software',
    description: 'Secure citizen request, case-routing, status, and workflow software shaped around how local-government departments operate.',
    path: '/citizen-request-management-software'
  },
  '/enterprise': {
    title: 'Enterprise Software & Automation',
    description: 'Custom enterprise software, workflow automation, cloud architecture, systems integration, and AI implementation planning.',
    path: '/enterprise'
  },
  '/local-business': {
    title: 'Local Business Software Development',
    description: 'Websites, mobile apps, and custom software for South Florida service businesses that need better lead and workflow systems.',
    path: '/local-business'
  },
  '/fort-lauderdale-custom-software-development': {
    title: 'Fort Lauderdale Software Development',
    description: 'Custom software, portals, integrations, and workflow automation for Fort Lauderdale and South Florida organizations.',
    path: '/fort-lauderdale-custom-software-development'
  },
  '/capabilities': {
    title: 'Custom Software Development Services',
    description: 'Full-stack custom software, mobile apps, cloud architecture, workflow automation, AI planning, and systems integration.',
    path: '/capabilities'
  },
  '/case-studies': {
    title: 'Software Development Case Studies',
    description: 'Examples of custom software work across mHealth, campus concepts, enterprise middleware, and digital infrastructure.',
    path: '/case-studies'
  },
  '/about': {
    title: 'About Bare Force One',
    description: 'Bare Force One is a custom software and digital transformation firm based in Plantation, serving Fort Lauderdale, South Florida, and nationwide.',
    path: '/about'
  },
  '/contact': {
    title: 'Contact Bare Force One',
    description: 'Discuss a custom software project for government, enterprise, or local operations with Bare Force One. Serving South Florida and nationwide.',
    path: '/contact'
  },
  '/request-proposal': {
    title: 'Request a Software Proposal',
    description: 'Share your project requirements and request a structured capability response from Bare Force One.',
    path: '/request-proposal'
  },
  '/insights': {
    title: 'Software Development Insights',
    description: 'Practical perspectives on government modernization, enterprise automation, cloud architecture, and field-team software.',
    path: '/insights'
  },
  '/privacy-policy': {
    title: 'Privacy Policy — Bare Force One LLC',
    description: 'Privacy Policy for Bare Force One LLC. Learn how we collect, use, and protect your information.',
    path: '/privacy-policy'
  },
  '/terms': {
    title: 'Terms & Conditions — Bare Force One LLC',
    description: 'Terms and Conditions for Bare Force One LLC. Read our terms of service, SMS policy, and website usage guidelines.',
    path: '/terms'
  }
};

export const STATIC_PUBLIC_ROUTES = Object.freeze(Object.keys(ROUTE_SEO));
